import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import {
  getLocalStorageKey,
  setLocalStorageKey,
} from '@/helpers/browser-storage'
import dayjs from '@/services/date/index'
import toast from '@services/toasts/index.js'

const getDefaultState = () => {
  return {
    presets: getLocalStorageKey('app.orgTree.presets') || {},
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    presets: (state, getters, rootState, rootGetters) => {
      return state.presets[rootGetters['auth/currentUserId']] ?? []
    },
    getPresetByKey: (state, getters) => (key) => {
      return getters.presets?.find((preset) => preset.key === key)
    },
  },
  mutations: {
    UPSERT_PRESET(state, { payload, adminId }) {
      // Remove preset if exists
      let preset = state.presets ? state.presets[adminId] ?? [] : []

      if (!isNullOrEmptyArray(preset)) {
        preset = preset.filter((preset) => preset.key !== payload.key)
      }

      preset.push(payload)

      state.presets[adminId] = preset

      // Cache in local storage
      setLocalStorageKey('app.orgTree.presets', state.presets) // FIXME: Use IndexedDB for Vue3 with Dexie
    },
    DELETE_PRESET(state, { key, adminId }) {
      let preset = state.presets ? state.presets[adminId] ?? [] : []

      if (!isNullOrEmptyArray(preset)) {
        preset = preset.filter((preset) => preset.key !== key)

        state.presets[adminId] = preset

        // Cache in local storage
        setLocalStorageKey('app.orgTree.presets', state.presets) // FIXME: Use IndexedDB for Vue3 with Dexie
      }
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    /**
     * Inserts or updates a preset
     * @param {{ key: string, name: string, favourite: boolean, selection: array }} payload
     */
    upsertPreset({ commit, getters, rootGetters }, payload) {
      const foundPreset = getters.getPresetByKey(payload.key)
      let presetToSave = {}

      if (!foundPreset) {
        presetToSave = {
          ...payload,
          ...{
            updatedDate: null,
            createdDate: dayjs(),
            createdBy: rootGetters['auth/currentUserId'] || null,
          },
        }
      } else {
        presetToSave = {
          ...foundPreset,
          ...payload,
          ...{
            updatedDate: dayjs(),
            updatedBy: rootGetters['auth/currentUserId'] || null,
          },
        }
      }

      commit('UPSERT_PRESET', {
        payload: presetToSave,
        adminId: rootGetters['auth/currentUserId'],
      })
    },
    togglePresetFavouriteState({ dispatch, getters }, key) {
      const foundPreset = getters.getPresetByKey(key)

      if (!foundPreset) {
        console.error(`Preset with key '${key}' not found`)
        return
      }

      const presetToUpdate = {
        ...foundPreset,
        ...{ favourite: !foundPreset.favourite },
      }

      dispatch('upsertPreset', presetToUpdate)
    },
    deletePreset({ getters, commit, rootGetters }, key) {
      const foundPreset = getters.getPresetByKey(key)

      if (!foundPreset) {
        console.error(`Preset with key '${key}' not found`)
        return
      }

      commit('DELETE_PRESET', {
        key,
        adminId: rootGetters['auth/currentUserId'],
      })

      toast.success(`Deleted ${foundPreset.title}`)
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
